import {NetworkAPIVersion, NetworkParamType} from '@common/network/network.utils';

export default {
  searchPrompt: {
    url: 'api/search-assist/search-for-prompt/',
    method: 'get',
    apiVersion: NetworkAPIVersion.noVersion,
    params: {
      search_prompt: [NetworkParamType.string],
    },
  },
  searchFollowUp: {
    url: 'api/search-assist/search-follow-up/',
    method: 'get',
    apiVersion: NetworkAPIVersion.noVersion,
    params: {
      search_url: [NetworkParamType.string],
      follow_up_prompt: [NetworkParamType.string],
    },
  },
  contextualizeDatePeriod: {
    url: 'api/search-assist/contextualize-date-period/',
    method: 'post',
    apiVersion: NetworkAPIVersion.noVersion,
    params: {
      place: [NetworkParamType.string],
      date_period: [NetworkParamType.string],
      event_label: [NetworkParamType.string],
      follow_up_question: [NetworkParamType.string],
    },
  },
  contextualizeDatePeriodReaction: {
    url: 'api/search-assist/contextualize-date-period/reaction/',
    method: 'post',
    apiVersion: NetworkAPIVersion.noVersion,
    params: {
      text: [NetworkParamType.string],
      question: [NetworkParamType.string],
      reaction: [NetworkParamType.string],
    },
  },
};
